module.exports = __webpack_public_path__ + "static/img/logo_top_2018.2813576.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/imgs/logo_top_2018.png
// module id = C12a
// module chunks = 1